import http from "../utils/http";

const PRODUCT_FIELDS = [
  "id",
  "documentId",
  "title",
  "offer_id",
  "article",
  "sku",
  "attrs",
  "is_active",
  "image_url",
  "cost_price",
  "marketplace_economics",
];

function mapProduct(raw) {
  const attrs = raw.attributes || {};
  const source = { ...attrs, ...raw };
  return {
    id: source.id,
    documentId: source.documentId,
    title: source.title || "Без названия",
    offer_id: source.offer_id || "",
    article: source.article || source.offer_id || "",
    sku: source.sku || "",
    attrs: source.attrs || {},
    is_active: source.is_active !== false,
    image_url: source.image_url || "",
    cost_price: Number(source.cost_price) || 0,
    marketplace_economics: source.marketplace_economics || {},
  };
}

export async function fetchAllProducts(pageSize = 100) {
  const result = [];
  let page = 1;
  let total = null;

  while (total === null || result.length < total) {
    const params = {
      "pagination[page]": page,
      "pagination[pageSize]": pageSize,
      "sort[0]": "title:asc",
    };
    PRODUCT_FIELDS.forEach((field, index) => {
      params[`fields[${index}]`] = field;
    });

    const response = await http.get("/products", { params });
    const rows = (response.data?.data || []).map(mapProduct);
    result.push(...rows);
    total = response.data?.meta?.pagination?.total ?? result.length;
    if (!rows.length) break;
    page += 1;
  }

  return result;
}

export async function updateProduct(documentId, patch) {
  const response = await http.put(
    `/products/${documentId}`,
    { data: patch },
    { params: { status: "published" } },
  );
  return mapProduct(response.data?.data || {});
}
